import { LeaderFieldModeService } from '@one/app/shared/services/auth/leader-field-mode.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EQimaButtonSize, EQimaButtonStyle, EQimaSnackbarType, QimaButtonModule, QimaSnackbarService } from '@qima/ngx-qima';
import { finalize } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'one-leader-field-mode-button',
  standalone: true,
  imports: [QimaButtonModule, TranslateModule],
  templateUrl: './leader-field-mode-button.component.html',
  styleUrl: './leader-field-mode-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaderFieldModeButtonComponent implements OnInit {
  public canShow = false;
  public isSwitching = false;

  public readonly buttonSizes: typeof EQimaButtonSize = EQimaButtonSize;
  public readonly buttonStyles: typeof EQimaButtonStyle = EQimaButtonStyle;

  private readonly _leaderFieldModeService = inject(LeaderFieldModeService);
  private readonly _snackbarService = inject(QimaSnackbarService);
  private readonly _translateService = inject(TranslateService);
  private readonly _changeDetectorRef = inject(ChangeDetectorRef);

  public ngOnInit(): void {
    this._leaderFieldModeService
      .canShowFieldMode$()
      .pipe(untilDestroyed(this))
      .subscribe((canShow): void => {
        this.canShow = canShow;
        this._changeDetectorRef.markForCheck();
      });
  }

  public switchToFieldMode(): void {
    if (!this.canShow || this.isSwitching) {
      return;
    }

    this.isSwitching = true;
    this._changeDetectorRef.markForCheck();
    this._leaderFieldModeService
      .switchToFieldModeAndNavigateToIspHome$()
      .pipe(
        finalize((): void => {
          this.isSwitching = false;
          this._changeDetectorRef.markForCheck();
        }),
        untilDestroyed(this)
      )
      .subscribe({
        error: (): void => {
          this._snackbarService.open({
            type: EQimaSnackbarType.ERROR,
            message: this._translateService.instant('leader-field-mode.switch-error'),
          });
        },
      });
  }
}
